import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	modalHeader: {
		id: 'portfolio-3-summary-page.ui.summary-page-header.date-range-picker.date-range-modal.modal-header',
		defaultMessage: 'Select date range',
		description: 'Heading of the date range modal, where users can select their date range',
	},
});
